import { Check } from "lucide-react";
import { Reveal } from "../components/Reveal";
import CtaButton from "../components/CtaButton";

const PUNKTE = [
  "Wie viele Ihrer Entscheider es im DACH-Raum tatsächlich gibt, als konkrete Zahl",
  "Wie aktiv diese Zielgruppe auf LinkedIn ist",
  "Mit welcher Botschaft man sie ansprechen würde",
  "Wie viele Entscheidergespräche pro Monat realistisch sind",
  "Ob sich eine Zusammenarbeit für Sie rechnet"
];

export default function Analyse() {
  return (
    <section className="bg-white py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <div className="flex items-center gap-4">
              <span className="h-px w-10 bg-navy/40" />
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-textgrau">Die Zielgruppen-Analyse</p>
            </div>
            <h2
              className="mt-6 text-2xl font-medium leading-snug tracking-[-0.01em] text-textdunkel sm:text-3xl lg:text-4xl"
              data-testid="analyse-ueberschrift"
            >
              45 Minuten, nach denen Sie wissen, ob LinkedIn Ihr Kanal ist
            </h2>
            <p className="mt-6 text-base leading-[1.85] text-textgrau">
              In der Zielgruppen-Analyse schaue ich mir mit Ihnen persönlich Ihre Zielgruppe an. Live im Sales
              Navigator, auf Ihrem Bildschirm. Sie bekommen eine ehrliche Einschätzung, auch wenn die Antwort lautet,
              dass LinkedIn für Sie nicht der richtige Weg ist.
            </p>
            <p className="mt-4 text-base leading-[1.85] text-textgrau" data-testid="analyse-messzahl">
              Wie viele Entscheidergespräche pro Monat realistisch sind, sage ich Ihnen vorab. An dieser Zahl messen wir uns,
              wenn wir zusammenarbeiten.
            </p>
            <div className="mt-9 flex items-center gap-4" data-testid="analyse-zitat">
              <img
                src="/patrick-haefner.webp"
                alt="Patrick Häfner"
                className="h-11 w-11 shrink-0 rounded-full border border-navy/20 object-cover object-top"
                loading="lazy"
              />
              <p className="text-sm leading-[1.8] text-textdunkel sm:text-base">
                „Den Termin führe ich selbst, nicht ein Vertriebsmitarbeiter.“ — Patrick Häfner
              </p>
            </div>
            <div className="mt-10">
              <CtaButton testid="cta-analyse" />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="h-full rounded-[2px] border border-navy/10 bg-hellblau/40 p-8 sm:p-10" data-testid="analyse-liste">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-textgrau">Was Sie nach dem Termin wissen:</p>
              <ul className="mt-2 divide-y divide-navy/10">
                {PUNKTE.map((p, i) => (
                  <li key={p} className="flex items-start gap-4 py-4" data-testid={`analyse-punkt-${i + 1}`}>
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gruen/10 text-gruen">
                      <Check size={13} strokeWidth={2.5} />
                    </span>
                    <span className="text-sm leading-[1.8] text-textdunkel sm:text-base">{p}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6 rounded-[2px] bg-hellblau p-5 text-sm leading-[1.8] text-textdunkel" data-testid="analyse-hinweis">
                Ich führe maximal drei Analysen pro Tag und nehme pro Monat zwei bis drei neue Kunden auf. Wenn Sie
                sich eine Analyse sichern möchten, buchen Sie bitte einen der freien Termine.
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
